import { MoreOutlined } from "@ant-design/icons";
import { Button, ButtonProps } from "antd";
import { ReactNode } from "react";
import ActionsPopover, { ActionsPopoverProps } from "../ActionsPopOver/ActionsPopOver";
import styles from "./MoreButton.module.scss";

export interface MoreButtonProps extends ActionsPopoverProps {
  buttonProps?: ButtonProps;
  actions: ReactNode;
}

export default function MoreButton({ actions, buttonProps, ...props }: MoreButtonProps) {
  return (
    <ActionsPopover
      trigger={["click"]}
      actions={actions}
      {...props}
    >
      <Button
        className={styles.MoreButton}
        {...buttonProps}
      >
        <MoreOutlined />
      </Button>
    </ActionsPopover>
  );
}
